import { FreeTShirt } from '@bgea-js/form-templates';
import customConfirmationFronteraTShirt from "../../../../src/content/frontera-giveaway-tshirts/customConfirmation";
import customConfirmationFronteraTShirtES from "../../../../src/content/frontera-giveaway-tshirts/customConfirmationES";
import * as React from 'react';
export default {
  FreeTShirt,
  customConfirmationFronteraTShirt,
  customConfirmationFronteraTShirtES,
  React
};